import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";

export const CookieNotice = () => {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("sedlo_cookie_consent");
    if (!consent) setVisible(true);
  }, []);

  const decide = (value) => {
    localStorage.setItem("sedlo_cookie_consent", value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-notice"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-0 inset-x-0 z-[95] p-4"
        >
          <div className="max-w-4xl mx-auto bg-navy text-white rounded-lg shadow-2xl p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <Cookie className="w-6 h-6 text-brand shrink-0" />
            <p className="text-sm text-white/80 flex-1">
              {t.cookie.text}{" "}
              <Link to="/ochrana-osobnych-udajov" className="text-brand underline">{t.cookie.link}</Link>.
            </p>
            <div className="flex gap-2 shrink-0">
              <button data-testid="cookie-decline" onClick={() => decide("declined")} className="text-sm px-4 py-2 rounded-md border border-white/20 hover:bg-white/10 transition-colors">
                {t.cookie.decline}
              </button>
              <button data-testid="cookie-accept" onClick={() => decide("accepted")} className="btn-lift text-sm px-4 py-2 rounded-md bg-brand hover:bg-brand-hover font-semibold">
                {t.cookie.accept}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
